/* global Swiper, elementorFrontend */
(function () {
  function initCategoryImageCarousels() {
    document
      .querySelectorAll(".category-image-carousel-wrapper")
      .forEach(function (wrapperEl) {
        if (wrapperEl.dataset.swiperInit) return;

        var swiperContainer = wrapperEl.querySelector(".swiper");
        if (!swiperContainer) return;

        var slidesToShow = parseInt(wrapperEl.dataset.slidesToShow, 10) || 1;

        if (typeof Swiper === "undefined") {
          // Swiper library not loaded yet (Elementor loads it lazily when
          // an image-carousel widget exists on the page). Retry shortly.
          setTimeout(initCategoryImageCarousels, 200);
          return;
        }

        var swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: slidesToShow,
          spaceBetween: 0,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          speed: 400,
        });

        // Elementor's own widget CSS has:
        // .elementor-image-carousel-wrapper:not(.swiper-initialized) .swiper-slide {
        //     max-width: calc(100% / var(--e-image-carousel-slides-to-show, 3));
        // }
        // This is Elementor's "before Swiper is ready" fallback layout, meant to
        // be neutralized once Swiper finishes initializing. The Swiper library
        // itself only adds "swiper-initialized" to the INNER .swiper element,
        // but Elementor's selector checks the OUTER .elementor-image-carousel-wrapper.
        // Since we reuse Elementor's markup/classes for CSS compatibility, we need
        // to mirror that class onto the outer wrapper ourselves, or the fallback
        // max-width rule stays active forever and stacks all slides side by side.
        wrapperEl.classList.add("swiper-initialized");

        // carousel-cta.js looks for swiperEl.swiper on the
        // .elementor-image-carousel-wrapper element itself.
        wrapperEl.swiper = swiperInstance;
        wrapperEl.dataset.swiperInit = "true";
      });
  }

  function ready(fn) {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(function () {
    setTimeout(initCategoryImageCarousels, 100);
  });

  window.addEventListener("elementor/frontend/init", function () {
    if (window.elementorFrontend && elementorFrontend.hooks) {
      elementorFrontend.hooks.addAction(
        "frontend/element_ready/category-image-carousel.default",
        function () {
          setTimeout(initCategoryImageCarousels, 100);
        },
      );
    }
  });
})();
